import { inject, InjectionToken } from '@angular/core';

export interface HlmTooltipConfig {
  variant: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size: 'default' | 'sm' | 'lg';
  position: 'top' | 'bottom' | 'left' | 'right';
  delay: number;
  maxWidth: string;
}

export const defaultHlmTooltipConfig: HlmTooltipConfig = {
  variant: 'default',
  size: 'default',
  position: 'top',
  delay: 500,
  maxWidth: '300px',
};

export const HLM_TOOLTIP_CONFIG = new InjectionToken<HlmTooltipConfig>('HLM_TOOLTIP_CONFIG', {
  providedIn: 'root',
  factory: () => defaultHlmTooltipConfig,
});

export function injectHlmTooltipConfig(): HlmTooltipConfig {
  return inject(HLM_TOOLTIP_CONFIG);
}
